<template>
    <div>
      <div class="row" v-if="[3].includes(logged_in_user.group_id)">
        <div class="col-12">
          <router-link :to="{ name:'AdminExternalSipAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i> Add External SIP Profile
          </router-link>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-8">
          <table class="table table-striped">
            <thead class="bg-hub-primary text-white">
            <tr>
              <th>Name</th>
              <th>Gateway</th>
              <th>Manage</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="intercom_external_sip in filtered_intercom_external_sips"
                :key="intercom_external_sip.intercom_external_sip_id">
              <td>{{ intercom_external_sip.name }}</td>
              <td>{{ intercom_external_sip.gateway }}</td>
              <td>
                <div class="dropdown" v-if="[3].includes(logged_in_user.group_id)">
                  <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <router-link :to="{ name:'AdminExternalSipEdit', params: { intercom_external_sip_id: intercom_external_sip.intercom_external_sip_id } }"
                                 class="dropdown-item"><i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                    </router-link>
                    <a class="dropdown-item" href="#" onclick="return false" @click="deleteIntercomExternalSip(intercom_external_sip)"><i
                      class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete</a>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      intercom_external_sips: 'allIntercomExternalSips',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_intercom_external_sips: function () {
      return this.intercom_external_sips.filter(intercomExternalSip => intercomExternalSip.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getIntercomExternalSips')
  },
  methods: {
    ...mapActions([
      'deleteIntercomExternalSip'
    ])
  }
}
</script>

<style scoped>

</style>
